import PropTypes from 'prop-types';

export const glJournalsShape = {
  periodName: PropTypes.string.isRequired,
  countryTaxType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  activity: PropTypes.string.isRequired,
  slAccount: PropTypes.string.isRequired,
  gaap: PropTypes.string,
  g2s: PropTypes.string,
  line: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  direction: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  glAccountCurrent: PropTypes.string,
  glAccountPrior: PropTypes.string,
  glAccount2ndPrior: PropTypes.string,
};

export const GlJournalPropTypes = PropTypes.shape(glJournalsShape);

export const GlJournalsPropTypes = PropTypes.arrayOf(GlJournalPropTypes);
